import { StateCreator } from "zustand";
import { BoundStore } from "./bound.store";

interface ActivityFeedState {
  firstColdStartAt: number | null;
  activityFeedReadUpToAt: number | null;
}

interface ActivityFeedActions {
  markActivityFeedRead: () => void;
  setFirstColdStartAt: () => void;
  resetActivityFeedRead: () => void;
}

export interface ActivityFeedSlice extends ActivityFeedState, ActivityFeedActions {}

export const createActivityFeedSlice: StateCreator<BoundStore, [["zustand/devtools", never]], [], ActivityFeedSlice> = (
  set,
  get,
) => ({
  firstColdStartAt: null,
  activityFeedReadUpToAt: null,

  setFirstColdStartAt: () => {
    const state = get();

    if (state.firstColdStartAt) return;

    set({ firstColdStartAt: Date.now() });
  },

  markActivityFeedRead: () => {
    set({ activityFeedReadUpToAt: Date.now() });
  },

  resetActivityFeedRead: () => {
    set({ activityFeedReadUpToAt: null });
  },
});
